import { Theme, ThemePanel } from '@radix-ui/themes';
import '@radix-ui/themes/styles.css';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import App from './App';
import './index.scss';
import store from './redux/store';
import reportWebVitals from './reportWebVitals';
import { FullPageLoader } from './components/common/FullPageLoader';
import { useAppSelector } from './hooks/hooks';
import { BASE_URL, UPLOAD_IMAGES } from './utils/constants';
import { ThemeProvider } from './pages/Manager/ThemeProvider';
import { IES } from './utils/labels';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
//useEffect(() => {
  const favicon = document.querySelector("link[rel='icon']");
  if (favicon) {
    favicon.setAttribute("href", `${IES.FAVICON}`);
  }
//}, []);

const queryClient = new QueryClient()

root.render(
  <React.StrictMode>
    <Provider store={store}>
    {/* <Theme appearance="light" accentColor="orange" grayColor="sand" radius="full" scaling="110%"> */}
      {/* <Theme accentColor="jade" grayColor='auto' appearance='dark' radius="full" scaling='100%' panelBackground='translucent' > */}
        <QueryClientProvider client={queryClient}>
          <ThemeProvider>
          <Toaster />
          <FullPageLoader />
          <App />
          </ThemeProvider>
        </QueryClientProvider>

        {/* <ThemePanel /> */}
      {/* </Theme> */}
    </Provider>
  </React.StrictMode>
);





// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
